import { Role, roleCollectionKey } from "@/entities/role";
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/functions";
import store from "@/store";

function convertToRole(
  data: firebase.firestore.DocumentData,
  ref: firebase.firestore.DocumentReference
): Role {
  return {
    ref,
    data: {
      ref: data.ref,
      type: data.type,
      loginId: data.loginId,
      code: data.code
    }
  };
}

export async function signInWithIdAndPassword(
  loginId: string,
  password: string,
  schoolId: string,
  token?: string
): Promise<firebase.User> {
  const studentLogin = firebase
    .app()
    .functions("asia-northeast1")
    .httpsCallable("student_login_v2");

  const loginRes = await studentLogin({
    loginId,
    password,
    schoolId,
    token
  });
  if (loginRes.data.error) {
    throw new Error(loginRes.data.error);
  }

  const userCredential = await firebase
    .auth()
    .signInWithCustomToken(loginRes.data.token);

  if (!userCredential.user) {
    throw new Error("");
  }

  return userCredential.user;
}

export async function signInWithCode(
  code: string,
  token?: string
): Promise<firebase.User> {
  const studentLogin = firebase
    .app()
    .functions("asia-northeast1")
    .httpsCallable("student_login_v2");

  const loginRes = await studentLogin({ code, token });
  if (loginRes.data.error) {
    throw new Error(loginRes.data.error);
  }

  const userCredential = await firebase
    .auth()
    .signInWithCustomToken(loginRes.data.token);

  if (!userCredential.user) {
    throw new Error("");
  }

  return userCredential.user;
}

export async function signOut() {
  try {
    store.commit("SET_IS_SIGNING_OUT", true);
    await firebase.auth().signOut();
  } finally {
    store.commit("SET_IS_SIGNING_OUT", false);
  }
}

export async function getRole(id: string): Promise<Role | null> {
  const db = firebase.firestore();

  try {
    const snapshot = await db.collection(roleCollectionKey).doc(id).get();
    const data = snapshot.data();
    if (!snapshot.exists || !data) {
      return null;
    }

    return convertToRole(data, snapshot.ref);
  } catch (e) {
    console.error(e);
    return null;
  }
}
